<body class="d-flex flex-column h-100">

	<!-- Begin page content -->
	<main class="flex-shrink-0">
		<div class="container">

			<!-- Guide -->
			<section #guide id="guide" [ngClass]="{paddingHas: leadershipList, paddingNo: noLeadershipList}">
				<div class="guide-content" *ngIf="leadershipList">
					<div class="container">
						<div class="row mt-3">
							<div class="col-lg-5 col-xl-4">
								<span translate class="title">kazakhstan.nav_leaderships</span>
							</div>
							<div class="col">
								<div class="line"></div>
							</div>
						</div>
						<div class="row mt-4">
							<div class="col-lg-6 col-md-6 mb-3" *ngFor="let item of leadershipList">
								<div class="box1" (click)="redirectGuideItem(item)">
									<div class="row">
										<div class="col-lg-12">
											<div class="info">
												<div class="row">
													<div class="col-lg-2">
														<img src="../../assets/img/3.png" alt="" style="margin: 20px 0;">
													</div>
													<div class="col-lg-3 portrait">
														<img style="width: 100%;" class="rounded-circle" src="{{item.image}}" alt="">
													</div>
													<div class="col-lg-7 guide-title">
														<span>{{item.name}}</span> <br>
														<p>{{item.rank}}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="no-results" [ngClass]="{block: noLeadershipList, none: leadershipList}">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="no-results-found-block text-center">
								<img src="../../assets/img/main/error.png" alt="" width="200">
								<div class="mt-2">
									<h2 style="font-weight: 600;">Результатов не найдено</h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</main>

</body>
